// Plain-English labels + tailwind pill classes for every module lifecycle
// state. Layman screens never see the raw enum: they see "Almost ready",
// "Needs your review", etc. Admin studios still get accurate colouring.
//
// Keep this map in sync with `models_storyboard.LearningModule.status`.

export const MODULE_STATUS_LABEL = {
    DRAFT: "Draft",
    STRUCTURING: "Building storyboard…",
    STORYBOARD_READY: "Storyboard needs approval",
    GENERATING_ASSETS: "Filming scenes…",
    BUILDING_PREVIEW: "Assembling preview…",
    READY_FOR_REVIEW: "Ready for review",
    AWAITING_APPROVAL: "Awaiting approval",
    CHANGES_REQUESTED: "Needs your review",
    APPROVED: "Approved — build to publish",
    PUBLISHED: "Published",
    FAILED: "Needs attention",
};

export const MODULE_STATUS_CLASS = {
    DRAFT: "bg-neutral-100 text-neutral-700",
    STRUCTURING: "bg-blue-50 text-blue-700",
    STORYBOARD_READY: "bg-amber-50 text-amber-800",
    AWAITING_APPROVAL: "bg-amber-50 text-amber-700",
    GENERATING_ASSETS: "bg-blue-50 text-blue-700",
    BUILDING_PREVIEW: "bg-blue-50 text-blue-700",
    READY_FOR_REVIEW: "bg-emerald-50 text-emerald-700",
    CHANGES_REQUESTED: "bg-amber-50 text-amber-700",
    APPROVED: "bg-emerald-50 text-emerald-700",
    PUBLISHED: "bg-neutral-900 text-white",
    FAILED: "bg-red-50 text-red-700",
};

export const RENDER_STATUS_LABEL = {
    NEVER_RENDERED: "Not built yet",
    RENDERING: "Building…",
    READY: "Ready",
    STALE: "Rebuild needed",
    FAILED: "Build failed",
};

export const RENDER_STATUS_CLASS = {
    NEVER_RENDERED: "bg-neutral-100 text-neutral-500",
    RENDERING: "bg-blue-50 text-blue-700",
    READY: "bg-emerald-50 text-emerald-700",
    STALE: "bg-amber-50 text-amber-800",
    FAILED: "bg-red-50 text-red-700",
};

export function moduleStatusLabel(status) {
    if (!status) return "—";
    return MODULE_STATUS_LABEL[status] ?? status.replaceAll("_", " ").toLowerCase();
}

export function renderStatusLabel(status) {
    if (!status) return RENDER_STATUS_LABEL.NEVER_RENDERED;
    return RENDER_STATUS_LABEL[status] ?? status.replaceAll("_", " ").toLowerCase();
}

export function moduleStatusPillClass(status) {
    return MODULE_STATUS_CLASS[status] || "bg-neutral-100 text-neutral-700";
}

export function renderStatusPillClass(status) {
    return RENDER_STATUS_CLASS[status || "NEVER_RENDERED"] || "bg-neutral-100 text-neutral-500";
}
